import { withEnvStage } from "./env";

const ID_TOKEN_KEY = withEnvStage("fjcidky");
const USER_ID_KEY = withEnvStage("fjcuid");
const USER_EMAIL_KEY = withEnvStage("fjcemail");
const USER_AUTH_FLOW_KEY = withEnvStage("fjcauthflow");
const USER_RESET_CODE_KEY = withEnvStage("fjcresetcode");
const LANGUAGE_KEY = withEnvStage("lang");
// const ACCESS_TOKEN_COOKIE_KEY = withEnvStage("fjc_access_token");
// const ID_TOKEN_COOKIE_KEY = withEnvStage("fjc_id_token");
// const USER_ID_COOKIE_KEY = withEnvStage("fjc_user_id");
const RECORDING_CATEGORY = {
  EXHORTATION: "exhortation",
  HYMN: "hymn",
  TEACHING: "teaching",
  ZOOM_PRAYER: "zoom_prayer",
  NIGHT_VIGIL: "prayer_vigil",
};
const DEFAULT_WIDTH = { base: "full", md: "80%", lg: "500px", "2xl": "525px" };
const FORM_PADDING_WIDTH = { base: "full", md: "70%", lg: "400px", "2xl": "425px" };
const SIDEBAR_WIDTH = { base: "270px", "2xl": "300px" };
const HEADING_TITLE = { base: "18px", md: "20px", lg: "28px" };
const PAGE_PADDING = { base: "16px", md: 0 };
const CARD_SPACING = { base: "24px", md: 7 };

export {
  USER_ID_KEY,
  USER_EMAIL_KEY,
  USER_AUTH_FLOW_KEY,
  USER_RESET_CODE_KEY,
  LANGUAGE_KEY,
  ID_TOKEN_KEY,
  FORM_PADDING_WIDTH,
  // ID_TOKEN_COOKIE_KEY,
  // ACCESS_TOKEN_COOKIE_KEY,
  // USER_ID_COOKIE_KEY,
  DEFAULT_WIDTH,
  HEADING_TITLE,
  SIDEBAR_WIDTH,
  PAGE_PADDING,
  CARD_SPACING,
  RECORDING_CATEGORY,
};
